import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { DvirFormsForm } from "./DvirFormsForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IDvirFormCreateProps {}

export const DvirFormCreate = (props: IDvirFormCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.DvirForm,
    (x) => x.create
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Create
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-dvir-forms.title.create">
        <DvirFormsForm />
      </Create>
    </FieldPermissionsContext.Provider>
  );
};
